<script setup lang="ts">
const modelValue = defineModel<Array<number>>({ default: [] });

const { t } = useI18n();
const roomValues = computed(() => [
  { value: 1, label: t('property.types_and_sub_types.studio') },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6+' },
]);
</script>

<template>
  <div>
    <IadChipGroup v-model="modelValue">
      <IadChip
        v-for="room in roomValues"
        :key="room.value"
        v-bind="room"
      />
    </IadChipGroup>
  </div>
</template>
